export default {
  header: {
    title: 'Użyj swoich punktów',
    balance: '{{value}} pkt dostępnych',
  },
  option_label: '{{value}} pkt',
  buttons: {
    none: 'Brak',
  },
  toasts: {
    enabled: 'Punkty lojalnościowe zostały zastosowane',
    removed: 'Punkty lojalnościowe usunięte',
  },
};
